import moment from 'moment';
import IEvent from '../../interfaces/IEvent';

export type EventKind = 'approved' | 'rejected' | 'pending' | 'integration' | 'neutral';

// Tokens do tema — o marcador da timeline usa a cor pela natureza do evento.
export const EVENT_KIND_COLOR: Record<EventKind, string> = {
  approved: 'success.main',
  rejected: 'error.main',
  pending: 'warning.main',
  integration: 'info.main',
  neutral: 'text.disabled',
};

const TRAILING_EXCLAMATION = /\s*!+\s*$/;
const CAPITALIZED_WORD = /^[A-ZÀ-Þ][a-zà-ÿ]+$/;
const SENTENCE_END = /[.!?:]$/;

const removeAccents = (value: string): string => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const formatEventDescription = (description: string): string => {
  const trimmed = (description || '').trim().replace(TRAILING_EXCLAMATION, '');
  if (!trimmed) return '';

  const words = trimmed.split(' ');

  return words
    .map((word, index) => {
      const startsSentence = index === 0 || SENTENCE_END.test(words[index - 1]);

      if (startsSentence) return `${word.charAt(0).toUpperCase()}${word.slice(1)}`;

      return CAPITALIZED_WORD.test(word) ? word.toLowerCase() : word;
    })
    .join(' ');
};

export const getEventKind = (description: string): EventKind => {
  const normalized = removeAccents((description || '').toLowerCase());

  if (/reprovad|rejeitad|negad|indeferid|nao\s+(aprovad|deferid)/.test(normalized)) return 'rejected';
  if (/aprovad|deferid/.test(normalized)) return 'approved';
  if (/integra/.test(normalized)) return 'integration';
  if (/pendente|analise|aguardando/.test(normalized)) return 'pending';

  return 'neutral';
};

export const formatEventDate = (createdAt?: Date): string => {
  const date = moment(createdAt);
  return createdAt && date.isValid() ? date.format('DD/MM/yyyy HH:mm') : '';
};

const getEventTime = (event: IEvent): number => {
  const date = moment(event.createdAt);
  return event.createdAt && date.isValid() ? date.valueOf() : Number.NEGATIVE_INFINITY;
};

export const sortEventsDesc = (events: IEvent[]): IEvent[] =>
  [...events].sort((a, b) => {
    const timeA = getEventTime(a);
    const timeB = getEventTime(b);
    return timeA === timeB ? 0 : timeB - timeA;
  });
